import { Box, Stack, Typography, useTheme } from "@mui/material";
import { APP_MAX_WIDTH } from "../../constants/layout";

interface Props {
    step: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
    title: string;
}

const ProgressHeader = (props: Props) => {
    const theme = useTheme();

    const { title, step } = props;

    const minutesLeft = 8 - step;

    return (
        <Stack width="100%" maxWidth={APP_MAX_WIDTH} alignItems="center">
            <Stack
                width="100%"
                maxWidth={APP_MAX_WIDTH}
                height="48px"
                justifyContent="flex-end"
                alignItems="flex-start"
            >
                <Box
                    width={`${(step / 8) * 100}%`}
                    height="4px"
                    bgcolor={theme.palette.primary.main}
                />
            </Stack>
            <Stack
                position="absolute"
                width="90%"
                maxWidth={(APP_MAX_WIDTH / 100) * 90}
                height="48px"
                justifyContent="center"
                alignItems="flex-start"
            >
                <Stack
                    justifyContent="center"
                    alignItems="flex-end"
                    direction="row"
                    spacing={0.5}
                >
                    <Typography
                        fontWeight={500}
                        fontSize="16px"
                        textAlign="center"
                        lineHeight="17.28px"
                        color="#1A1A1A"
                    >
                        {minutesLeft === 0 ? "100%" : `~${minutesLeft}`}
                    </Typography>
                    <Typography
                        fontWeight={500}
                        fontSize="10px"
                        textAlign="center"
                        lineHeight="10.8px"
                        color="#1A1A1A"
                    >
                        {minutesLeft === 0 ? "" : "min"}
                    </Typography>
                </Stack>
            </Stack>
            <Stack position="absolute" height="48px" justifyContent="center">
                <Typography
                    fontWeight={500}
                    fontSize="16px"
                    textAlign="center"
                    lineHeight="24px"
                >
                    {title}
                </Typography>
            </Stack>
        </Stack>
    );
};

export default ProgressHeader;
